import ChevronRight from '@material-ui/icons/ChevronRight'
import React from 'react'
import { FlexAlignItemsCenter, Typography } from 'webbook-airways'

export default function ReadMore({ variant = 'subtitle1', title }) {
  return (
    <FlexAlignItemsCenter>
      <Typography variant={variant}>{title}</Typography>
      <ChevronRight
        style={{
          fontSize: variant !== 'subtitle1' && 16,
          marginLeft: variant === 'subtitle1' && 5,
          marginBottom: variant !== 'subtitle1' && -1
        }}
      />
    </FlexAlignItemsCenter>
  )
}
